import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            const isSignupRegisterRoute = to.name === 'auth.signup.register'
            const isVerifyEmailRoute = to.name === 'auth.verify-email'

            if (!from.name && AuthService.isLoggedIn()) {
                if (isSignupRegisterRoute) {
                    return next({ name: 'errors.active-session' })
                }

                if (isVerifyEmailRoute && Number(to.params.userId) !== AuthService.getUser().id) {
                    return next({ name: 'errors.active-session' })
                }
            }

            return next()
        })
    },
}
